import { createI18n } from 'vue-i18n'
import { computed } from 'vue'
import ar from './locales/ar.json'
import fr from './locales/fr.json'

// Get locale from localStorage or default to 'ar'
const locale = localStorage.getItem('locale') || 'ar'

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'ar',
  messages: {
    ar,
    fr
  }
})

// Export composable to use RTL
export function useRTL() {
  const isRTL = computed(() => {
    return i18n.global.locale.value === 'ar'
  })

  return {
    isRTL
  }
}

export default i18n
